import "../assets/css/errorAndMaintenance.css";
import dokokoko from "../assets/images/dokokoko.gif";
import doko from "../assets/images/doko.png";
import koko from "../assets/images/koko.png";
import { CountdownTimer } from "../components/countdownTimer";
import { Status } from "../constants/status";

export const ErrorAndMaintenance = ({
  labelTitle = Status.getStatusValue(Status.MAINTENANCE),
  labelDescription = null,
  isGoHome = false,
  maintenance = null,
}) => {
  return (
    <div className="error-maintenance-container">
      <img src={koko} alt="koko" className="image-left" />
      <div className="image-center">
        <img src={dokokoko} alt="dokokoko" />
        <br />
        <label className="label-title">{labelTitle}</label>
        <br />
        {labelDescription ? <p>{labelDescription}</p> : null}
        <br />
        {isGoHome ? <a href="/">Go to Home</a> : null}
        {maintenance ? (
          <div>
            <label className="label-description">Come back in</label>
            <CountdownTimer targetDate={maintenance.endDateTime} />
          </div>
        ) : null}
      </div>
      <img src={doko} alt="doko" className="image-right" />
    </div>
  );
};
